import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import './ServiceTable.css';
import Modal from 'react-responsive-modal';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';
import { getLocalizedDateTime, getLocalizedString, getLocalizedTime } from '../../localization/LocalizedString';
import Button from '../forms/Button';
import { requestAckIssue } from '../../actions/issue';
import IssueListItem from './IssueListItem';

class IssueTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      isModalLoading: true,
      id: null,
      mediaId: null,
      type: null,
      description: null,
      mediaIds: null,
      createdAt: null,
      userId: null,
      ack: null,
    };
  }

  columnsCount = () => 8;

  showModal = (document) => {
    this.setState({
      modalOpen: true,
      id: document._id,
      mediaId: document.mediaId,
      type: document.type,
      description: document.description,
      mediaIds: document.mediaIds,
      createdAt: document.createdAt,
      userId: document.userId,
      ack: document.ack,
    });
  };

  closeModal = () => {
    this.setState({
      modalOpen: false,
      isModalLoading: true,
      id: null,
      mediaId: null,
      type: null,
      description: null,
      mediaIds: null,
      createdAt: null,
      userId: null,
      ack: null,
    });
  };

  isEmpty = (str) => (!str || str.length === 0);

  ackIssue = (id) => {
    const { requestAckIssue, translate, requestReport, page } = this.props;
    return () => {
      requestAckIssue(
        id,
        (e) => toast.error(translate('issue_ack_error')),
        () => {
          this.closeModal();
          toast(translate('issue_ack_ok'));
          requestReport(page);
        },
      );
    };
  }

  renderHeader = () => {
    const { translate } = this.props;

    return (
      <thead>
        <tr className="report-table-header_service">
          <th className="report-table-th_service">{translate('service_report.column_issue.date')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.type')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.description')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.customer')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.end_customer')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.address')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.city')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.service_site')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.message')}</th>
        </tr>
      </thead>
    );
  };

  renderModal() {
    const { translate, currentLanguage } = this.props;
    const { modalOpen: open } = this.state;
    const {
      id,
      type,
      description,
      mediaId, mediaIds,
      userId,
      createdAt,
      ack,
    } = this.state;

    const mediaUrl = !this.isEmpty(mediaIds) ? mediaIds.map((imageId, key) => `/api/media/${imageId}`)
      : (!this.isEmpty(mediaId) ? [`/api/media/${mediaId}`] : null);

    console.log(mediaUrl);

    const modalStyles = {
      modal: {
        minWidth: '400px',
        padding: '2rem',
        maxHeight: '90vh',
        overflowY: 'auto',
      },
    };
    const imageStyles = {
      paddingBottom: '10px',
      objectFit: 'contain',
      maxHeight: '600px',
      width: '100%',
      height: '100%',
    };

    const time = createdAt ? getLocalizedTime(new Date(createdAt), currentLanguage) : "";
    const ackUI = ack ? (
        <div>
          <h5>{translate('issue_ack_time')}: {getLocalizedDateTime(new Date(ack.timestamp), currentLanguage)}</h5>
          <h5>{translate('issue_ack_user')}: {ack.userId}</h5>
        </div>
    ) : (
        <Button style={{margin: '20px 0px 0px 0px', width: '200px'}} onClick={this.ackIssue(id)}>{translate('issue_ack')}</Button>
    );

    return (
        <Modal open={open} onClose={this.closeModal} little showCloseIcon={false} styles={modalStyles}>
          <div className="issue-item">
            <button type="button" className="close" aria-label="Close" onClick={this.closeModal}
                    style={{float: 'right'}}><span aria-hidden="true">&times;</span></button>
            <h5>{translate('issue')}&nbsp;({getLocalizedString(type, currentLanguage)})</h5>
            <h5>{translate('issue_created')}: {time}</h5>
            <h5>{translate('issue_creator')}: {userId}</h5>
            <h5>{translate('issue_message')}:</h5>
            <div style={{marginTop: '1.5em', whiteSpace: 'pre-line'}}>{description}</div>
            <div>
              {ackUI}
            </div>
          </div>

          {!!mediaUrl &&
              mediaUrl.map((imageUrl, key) =>
                  <a href={imageUrl} target='_blank'>
                    <img src={imageUrl} alt="" style={imageStyles} />
                  </a>)
          }
        </Modal>
    );
  }

  renderModalButton = (id) => {
    const { translate } = this.props;
    return (
        <button className="button-without-style text-align-left" onClick={() => { this.showModal(id); }}>{translate('service_report.column_issue.view_post')}</button>
    );
  }

  renderLoadingInfo = () => {
    const { translate, isLoading } = this.props;
    return isLoading
      ? (
        <React.Fragment>
          <tr className="report-table-row_service">
            <td colSpan={this.columnsCount()}
                className="report-table-cell_service_no_border">
              {translate('service_report.search.loading')}
            </td>
          </tr>
        </React.Fragment>
      )
      : null;
  };

  renderResult = () => {
    const { translate, data, isLoading, currentLanguage } = this.props;
    if (isLoading) {
      return null;
    }

    const viewData = data.length > 0
      ? data.slice()
      : [];

    return (
      <React.Fragment>
        {viewData.length === 0 && (
          <tr>
            <td colSpan={this.columnsCount()}>
              {translate('service_report.search.no_data_found')}
            </td>
          </tr>
        )}

        {viewData.map((task) => (
          <IssueListItem key={task.id}
                         item={task}
                         currentLanguage={currentLanguage}
                         modalButton={this.renderModalButton(task)} />
        ))}
      </React.Fragment>
    );
  };

  render() {
    return (
      <div>
        <table className="report-table_service">
          {this.renderHeader()}
          <tbody>
            {this.renderLoadingInfo()}
            {this.renderResult()}
            {this.renderModal()}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestAckIssue,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
)(IssueTable);



// WEBPACK FOOTER //
// ./src/components/servicereport/IssueTable.js